module.exports = __webpack_public_path__ + "img/drag.da2c08bb.svg";